module.exports = __webpack_public_path__ + "img/img_company_thumb.51c595b1.jpeg";